<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-12
        h1.m-0
          i Reportes
    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col-12
          .card.p-0.ad_border2-primaryLight.rounded-xl
            .card-body
              table.w-100
                tr
                  td(colspan="3")
                    .h4.ad_text-primary Reporte de usuarios
                  td.text-right(width="10%")
                    button.btn.btn-secondary-border.px-4.py-2.font-1em(@click="userReport()")
                      | Descargar
                tr
                  td
                    .h4.ad_text-primary Reporte Lideres y colaboradores
                  td.px-2(valign="bottom")
                    multiselect.col.px-0(
                      v-model="leadersRSelected",
                      :options="leadersr",
                      :multiple="true",
                      :close-on-select="false",
                      :clear-on-select="false",
                      placeholder="Lideres",
                      label="name",
                      track-by="id",
                      :preselect-first="false",
                      @input="changeLeadersCollabd")
                  td.px-2(valign="bottom")
                    label.text-nowrap.font-weight-bold Activos
                    input.d-inline-block.ml-2(type="checkbox" v-model="activesRLC" title='Selecciona si solo quiere líderes activos')
                  td.text-right.pt-5(width="10%")
                    button.btn.btn-secondary-border.px-4.py-2.font-1em(@click="collabsLidersReport()" :disabled="!enableCollabLeaders")
                      | Descargar
                tr
                  td
                    .h4.ad_text-primary Reporte Compromisos pendientes
                  td.px-2(colspan="2" valign="bottom")
                    multiselect.col.px-0(
                      v-model="leadersCompSelected",
                      :options="leaderscomp",
                      :multiple="true",
                      :close-on-select="false",
                      :clear-on-select="false",
                      placeholder="Lideres",
                      label="name",
                      track-by="id",
                      :preselect-first="false",
                      @input="changeLeadersCompPen")
                  td.text-right.pt-5(width="10%")
                    button.btn.btn-secondary-border.px-4.py-2.font-1em(@click="compPendReport()" :disabled="!enable_com_pen")
                      | Descargar
                tr
                  td
                    .h4.ad_text-primary Reporte Ejecución Herramientas MAC
                  td.px-2(valign="bottom")
                    label.text-nowrap.font-weight-bold Seleccione Año
                    .ad_select
                      select(v-model='year', @change="changeYear($event)")
                        option(:value="null" disabled selected) Año
                        option(:value="n" v-for="n in years") {{n}}
                  td.px-2(valign="bottom")
                    label.text-nowrap.font-weight-bold Seleccione semana
                    .ad_select
                      select(v-model='semana', @change="onChange($event)", :disabled="!enable_week")
                        option(:value="null" disabled selected) Semana
                        option(:value="numero", v-for="numero in weeks_mac") {{numero}}
                  td.text-right.pt-5(width="10%")
                    button.btn.btn-secondary-border.px-4.py-2.font-1em(@click="planReport()" :disabled="!enable")
                      | Descargar
                tr
                  td
                    .h4.ad_text-primary Reporte Observaciones de Calidad
                  td.px-2(valign="bottom")
                    label.text-nowrap.font-weight-bold Seleccione Año
                    .ad_select
                      select(v-model='year_eval', @change="changeYearP($event)")
                        option(:value="null" disabled selected) Año
                        option(:value="n" v-for="n in years") {{n}}
                  td.px-2(valign="bottom")
                    label.text-nowrap.font-weight-bold Seleccione semana
                    .ad_select
                      select(v-model='semanapauta', @change="weekpauta($event)", :disabled="!enable_week_p")
                        option(:value="null" disabled selected) Semana
                        option(:value="numero", v-for="numero in weeks_pauta") {{numero}}
                  td.text-right.pt-5(width="10%")
                    button.btn.btn-secondary-border.px-4.py-2.font-1em(@click="pautaReport()" :disabled="!enablePauta")
                      | Descargar
                tr
                  td
                    .h4.ad_text-primary Reporte SD/CP semanal
                  td.px-2(valign="bottom")
                    .row
                      .col-6
                        label.text-nowrap.font-weight-bold Seleccione Año
                        .ad_select
                          select(v-model='year_meetings', @change="changeYearM($event)")
                            option(:value="null" disabled selected) Año
                            option(:value="n" v-for="n in years") {{n}}
                      .col-6
                        label.text-nowrap.font-weight-bold Seleccione semana
                        .ad_select
                          select(v-model='weekmeetings', @change="chweekmeetings($event)", :disabled="!enable_week_m")
                            option(:value="null" disabled selected) Semana
                            option(:value="numero", v-for="numero in weeks_tracings") {{numero}}
                  td.px-2(valign="bottom")
                    label.text-nowrap.font-weight-bold Seleccione tipo
                    .ad_select
                      select(v-model='typemeetings', @change="chtypemeetings($event)", :disabled="!enable_type_m")
                        option(:value="null" disabled selected) Tipo
                        option(:value="type.name", v-for="type in types") {{type.name}}
                  td.text-right.pt-5(width="10%")
                    button.btn.btn-secondary-border.px-4.py-2.font-1em(@click="meetingsReport()" :disabled="!enableMeetings")
                      | Descargar
                tr
                  td
                    .h4.ad_text-primary Reporte Kpi Líder
                  td.px-2(valign="bottom")
                    label.text-nowrap.font-weight-bold Seleccione Año
                    .ad_select
                      select(v-model='year_kpil', @change="changeYearKl($event)")
                        option(:value="null" disabled selected) Año
                        option(:value="n" v-for="n in years") {{n}}
                  td.px-2(valign="bottom")
                    label.text-nowrap.font-weight-bold Seleccione semana
                    .ad_select
                      select(v-model='weekkpil', @change="changeWeekKpil($event)", :disabled="!enable_kpil")
                        option(:value="null" disabled selected) Semana
                        option(:value="numero", v-for="numero in weeks_kpi") {{numero}}
                  td.text-right.pt-5(width="10%")
                    button.btn.btn-secondary-border.px-4.py-2.font-1em(@click="kpilReport()" :disabled="!enableKpl")
                      | Descargar
                tr
                  td
                    .h4.ad_text-primary Resultado Observaciones de Calidad
                  td.px-2(valign="bottom")
                    .row
                      .col-4
                        label.text-nowrap.font-weight-bold Año
                        .ad_select
                          select(v-model='year_reval', @change="changeYearReval($event)")
                            option(:value="null" disabled selected) Año
                            option(:value="n" v-for="n in years") {{n}}
                      .col-4
                        label.text-nowrap.font-weight-bold Tipo
                        .ad_select
                          select(v-model='type_reval', @change="chtypereval($event)", :disabled="!enable_type_r")
                            option(:value="null" disabled selected) Tipo
                            option(:value="type.name", v-for="type in types_r") {{type.name}}
                      .col-4
                        label.text-nowrap.font-weight-bold Semana
                        div
                          multiselect.col.px-0(
                            v-model="weekreval",
                            :options="weeks_reval",
                            :multiple="true",
                            :close-on-select="false",
                            :clear-on-select="false",
                            placeholder="Semanas",
                            label="semana",
                            track-by="id",
                            :preselect-first="true",
                            @input="changeWeekReval",
                            :disabled="!enable_week_reval")
                  td.px-2(valign="bottom")
                    label.text-nowrap.font-weight-bold Seleccione Lider
                    multiselect.col.px-0(
                      v-model="leadersSelected",
                      :options="leaders",
                      :multiple="true",
                      :close-on-select="false",
                      :clear-on-select="false",
                      placeholder="Lideres",
                      label="name",
                      track-by="id",
                      :preselect-first="false",
                      @input="changeLeaders",
                      :disabled="!enable_leaders")
                  td.text-right.pt-5(width="10%")
                    button.btn.btn-secondary-border.px-4.py-2.font-1em(@click="RevalReport()" :disabled="!enableReval")
                      | Descargar
                tr
                  td
                    .h4.ad_text-primary Reporte Sesiones
                  td.px-2(valign="bottom")
                    label.text-nowrap.font-weight-bold Seleccione Año
                    .ad_select
                      select(v-model='year_sessions', @change="changeYearSession($event)")
                        option(:value="null" disabled selected) Año
                        option(:value="n" v-for="n in years") {{n}}
                  td.px-2(valign="bottom")
                    label.text-nowrap.font-weight-bold Seleccione semana
                    .ad_select
                      select(v-model='period', @change="changePeriodSession($event)", :disabled="!enable_period_session")
                        option(:value="null" disabled selected) Semana
                        option(:value="numero", v-for="numero in periods") {{numero}}
                  td.text-right.pt-5(width="10%")
                    button.btn.btn-secondary-border.px-4.py-2.font-1em(@click="getSessionsReport()" :disabled="!enable_session")
                      | Descargar
            
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import { saveAs } from 'file-saver';


export default {
  name: 'Reportes',
  data () {
    return {
      semana: 0,
      semanapauta: 0,
      weekmeetings: 0,
      weekkpil: 0,
      weekreval: [],
      periods: [1,2,3,4,5,6,7,8,9,10,11,12],
      firstWeek: `01/01/${new Date().getFullYear()}`,
      enable: false,
      enablePauta: false,
      enableMeetings: false,
      enableKpl: false,
      enableReval: false,
      enableCollabLeaders: false,
      enable_week: false,
      enable_week_p: false,
      enable_week_m: false,
      enable_type_m: false,
      enable_type_r: false,
      enable_kpil: false,
      enable_week_reval: false,
      enable_leaders: false,
      enable_r_leaders: false,
      enable_com_pen: false,
      enable_period_session: false,
      enable_session: false,
      years: [],
      year_eval: null,
      year: null,
      year_meetings: null,
      year_kpil: null,
      year_reval: null,
      year_sessions: null,
      typemeetings: null,
      type_reval: null,
      types: [{name: "SD"},{name: "CP"}, {name: "SD-CP"}],
      types_r: [{name: "SDA"},{name: "SDB"},{name: "CP"},{name: "DDD"},{name: "PS"}],
      weeks_mac: [],
      weeks_pauta: [],
      weeks_tracings: [],
      weeks_kpi: [],
      weeks_reval: [],
      leaders: [],
      leadersr: [{id: null, name: 'Todos'}],
      leaderscomp: [{id: null, name: 'Todos'}],
      leadersSelected: [],
      leadersRSelected: [],
      leadersCompSelected: [],
      activesRLC: null,
      period: null
    }
  },
  methods: {
    moment,
    ...mapActions('user', [
      'generateReport', 'kpiLiderReport', 'getLeaders', 'CollabsLidersReport', 'CommitmentsPendReport'
    ]),
    ...mapActions('plan', [
      'generateWeeklyReport'
    ]),
    ...mapActions('consultant', [
      'reportWeekEvaluations', 'revalReport'
    ]),
    ...mapActions('tracing', [
      'generateMeetingsReport'
    ]),
    ...mapActions('session', [
      'sessionsReport'
    ]),
    planReport() {
      const vm = this;
      const loading = vm.$toast.loading('Cargando...')      
      vm.generateWeeklyReport({week: vm.semana, year: vm.year}).then(result => {
        const blob = new Blob([result.bodyText], {type: "text/csv;charset=utf-8"});        
        saveAs(blob, `reporte-semana${vm.semana}.csv`);
        loading.hide();
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    pautaReport() {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')
      vm.reportWeekEvaluations({week: vm.semanapauta, year: vm.year_eval}).then(result => {
        const blob = new Blob([result.bodyText], {type: "text/csv;charset=utf-8"});        
        saveAs(blob, `reporte-semana${vm.semanapauta}.csv`);
        loading.hide();
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    userReport() {
      const vm = this;
      const loading = vm.$toast.loading('Cargando...')
      vm.generateReport().then(result => {
        const blob = new Blob([result.bodyText], {type: "text/csv;charset=utf-8"});
        saveAs(blob, `reporte-usuarios.csv`);
        loading.hide()    
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    meetingsReport() {
      const vm = this;
      const loading = vm.$toast.loading('Cargando...')
      vm.generateMeetingsReport({week_number: vm.weekmeetings , year: vm.year_meetings, type: vm.typemeetings}).then((result) => {
        const blob = new Blob([result.bodyText], {type: "text/csv;charset=utf-8"});
        saveAs(blob, `reporte-${vm.typemeetings}-${vm.weekmeetings}.csv`);
        loading.hide()     
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    kpilReport() {
      const vm = this;      
      const loading = vm.$toast.loading('Cargando...')
      let data = {year: vm.year_kpil, week: vm.weekkpil}
      let currentYear = moment().year();

      vm.kpiLiderReport(data).then(result => {
        const blob = new Blob([result.bodyText], {type: "text/csv;charset=utf-8"});
        saveAs(blob, `reporteKpiLiderAño${currentYear}Semana${vm.weekkpil}.csv`);
        loading.hide()    
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    RevalReport() {
      const vm = this;      
      const loading = vm.$toast.loading('Cargando...')
      let data = {year: vm.year_reval, weeks: vm.weekreval, leaders: vm.leadersSelected, type: vm.type_reval}
      let currentYear = moment().year();

      vm.revalReport(data).then(result => {
        const blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), result.bodyText], {type: "text/csv;charset=utf-8"});
        let weeksNumbers = '';
        let weeksLength = vm.weekreval.length - 1;
        for (let index in vm.weekreval) {
          weeksNumbers += vm.weekreval[index].semana;
          if (index < weeksLength) {
            weeksNumbers += '-';
          }
        }
        saveAs(blob, `resultObservAño${currentYear}Semana${weeksNumbers}Tipo${data.type}.csv`);
        loading.hide()    
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    collabsLidersReport() {
      const vm = this;
      const loading = vm.$toast.loading('Cargando...')
      vm.CollabsLidersReport({leaders: vm.leadersRSelected, onlyactive: vm.activesRLC}).then(result => {
        const blob = new Blob([result.bodyText], {type: "text/csv;charset=utf-8"});
        saveAs(blob, `reporte-usuarios.csv`);
        loading.hide()    
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    onChange(event) {
      if (event.target.value != null || event.target.value != '') {
        this.enable = true
      }
    },
    changePeriodSession(event) {
      if (event.target.value != null || event.target.value != '') {
        this.enable_session = true
      }
    },
    weekpauta(event) {
      if (event.target.value != null || event.target.value != '') {
        this.enablePauta = true
      }
    },
    changeWeekKpil(event) {
      if (event.target.value != null || event.target.value != '') {
        this.enableKpl = true
      }
    },
    chweekmeetings(event) {
      if (event.target.value != null || event.target.value != '') {
        this.enable_type_m = true
      }
    },
    changeWeekReval(event) {
      if (this.weekreval.length > 0) {
        this.enable_leaders = true;
      } else {
        this.enable_leaders = false;
      }
    },
    changeYearKl(event) {
      if (event.target.value != null || event.target.value != '') {
        this.getWeeks(event.target.value, 'kpi');
        this.enable_kpil = true
      }
    },
    changeYear(event) {
      if (event.target.value != null || event.target.value != '') {
        this.getWeeks(event.target.value, 'mac');
        this.enable_week = true
      }
    },
    changeYearP(event) {
      if (event.target.value != null || event.target.value != '') {
        this.getWeeks(event.target.value, 'pauta');
        this.enable_week_p = true
      }
    },
    changeYearM(event) {
      if (event.target.value != null || event.target.value != '') {
        this.getWeeks(event.target.value, 'tracings');
        this.enable_week_m = true
      }
    },
    changeYearReval(event) {
      if (event.target.value != null || event.target.value != '') {
        this.getWeeksForMultiSelect(event.target.value, 'reval').then(() => {
          this.enable_type_r = true
        });
      }
    },
    changeYearReval(event) {
      if (event.target.value != null || event.target.value != '') {
        this.getWeeksForMultiSelect(event.target.value, 'reval').then(() => {
          this.enable_type_r = true
        });
      }
    },
    changeYearSession(event) {
      if (event.target.value != null || event.target.value != '') {
        this.enable_period_session = true
      }
    },
    changeLeaders() {
      if (this.leadersSelected.length > 0) {
        this.enableReval = true
      } else {
        this.enableReval = false
      }
    },
    chtypemeetings(event) {
      if (event.target.value != null || event.target.value != '') {
        this.enableMeetings = true
      }
    },
    chtypereval(event) {
      if (event.target.value != null || event.target.value != '') {
        this.enable_week_reval = true
      }
    },
    getYears() {
      const vm = this;
      let currentYear = new Date().getFullYear();
      let startYear = 2019
      let yearslist = [];  
      while ( startYear <= currentYear ) {
          yearslist.push(startYear++);
      }   
      vm.years = yearslist;
    },
    getWeeks(year, variable) {
      const vm = this;
      let variableName = `weeks_${variable}`;
      vm[variableName] = moment({year: year}).isoWeeksInYear();
    },
    getWeeksForMultiSelect(year, variable) {
      return new Promise((resolve, reject) => {
        try {  
          const vm = this;
          let variableName = `weeks_${variable}`;
          let weeks = moment({year: year}).isoWeeksInYear();
          let index = 0;
          let numberstring = '';
          
          while (index < weeks) {
            numberstring = index + 1;
            vm[variableName].push({id: numberstring, semana: `${numberstring}`});
            index++;
          }
          resolve();
        } catch(e) {
          reject(e);
        }
      })
    },
    compPendReport() {
      const vm = this;
      const loading = vm.$toast.loading('Cargando...')
      vm.CommitmentsPendReport({leaders: vm.leadersCompSelected}).then(result => {
        const blob = new Blob([result.bodyText], {type: "text/csv;charset=utf-8"});
        saveAs(blob, `compromisos-pendientes-lideres.csv`);
        loading.hide()    
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    changeLeadersCompPen() {
      if (this.leadersCompSelected.length > 0) {
        this.enable_com_pen = true
      } else {
        this.enable_com_pen = false
      }
    },
    changeLeadersCollabd() {
      if (this.leadersRSelected.length > 0) {
        this.enableCollabLeaders = true
      } else {
        this.enableCollabLeaders = false
      }
    },
    getSessionsReport() {
      const vm = this;      
      const loading = vm.$toast.loading('Cargando...')
      let data = {year: vm.year_sessions, period: vm.period};

      vm.sessionsReport(data).then(result => {
        const blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), result.bodyText], {type: "text/csv;charset=utf-8"});
        let weeksNumbers = '';
        let weeksLength = vm.weekreval.length - 1;
        for (let index in vm.weekreval) {
          weeksNumbers += vm.weekreval[index].semana;
          if (index < weeksLength) {
            weeksNumbers += '-';
          }
        }
        saveAs(blob, `informeSesiones${data.period}-${data.year}.csv`);
        loading.hide()    
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    }
  },
  mounted() {
    const vm = this;
    vm.getYears();
    this.getLeaders().then((leadersfound) => {
      this.leaders = leadersfound;
      this.leadersr = this.leadersr.concat(leadersfound);
      this.leaderscomp = this.leaderscomp.concat(leadersfound);
      this.enable_r_leaders = true;
    }, (error) => {
      vm.$notify({
        type: "danger",
        title: "Notificación",
        content: error.payload.message,
        closeable: true,
        duration: 5000
      });
    });
  }
}
</script>

<style lang="stylus" scoped>
ul
  display flex
  margin 0
  padding 0
  align-items center
  justify-content space-between
  li
    display flex
</style>


// WEBPACK FOOTER //
// src/views/reportes.vue